import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import SurpriseQRReports from "./pages/surprise_qr/SurpriseQrReports";

import Sidebar from "./components/sidebar/Sidebar";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Layout from "./pages/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import NotificationSend from "./pages/notifications/NotificationSend";
import SignIn from "./pages/Auths/SignIn";

import Configure_ads from "./pages/Configure_Ads";
import Qr_code_designs from "./pages/Qr_code_designs";

// ⭐ NEW PAGES ⭐
import CreateStickerPack from "./pages/stickers/CreateStickerPack";
import ManageStickerPacks from "./pages/stickers/ManageStickerPacks";

import { decryptCookie } from "./utils/cookie";
import "./App.css";
import Sticker_Categories from "./pages/stickers/Sticker_Categories";
import DeleteRequests from "./pages/DeleteRequests";
import StickerReports from "./pages/stickers/StickerReports";
import SmartLinkReports from "./pages/smartlinks/SmartLinkReports";
import SurpriseCategories from "./pages/surprise_qr/SurpriseCategories";
import SurpriseContent from "./pages/surprise_qr/SurpriseContent";
import SurpriseQrReports from "./pages/surprise_qr/SurpriseQrReports";

const App: React.FC = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = decryptCookie("token");
    setIsAuthenticated(!!token);
  }, []);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  // 🔒 Protected Admin Routes
  const protectedRoutes = useMemo(
    () => (
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/qr-code-designs" element={<Qr_code_designs />} />

        {/* ⭐ NEW ROUTES FOR STICKERS ⭐ */}
        <Route path="/sticker-categories" element={<Sticker_Categories />} />
        <Route path="/stickers/create" element={<CreateStickerPack />} />
        <Route path="/stickers/edit/:id" element={<CreateStickerPack />} />
        <Route path="/stickers/manage" element={<ManageStickerPacks />} />
        <Route path="/delete-requests" element={<DeleteRequests />} />
        <Route path="/sticker-reports" element={<StickerReports />} />
        <Route path="/smart-link-reports" element={<SmartLinkReports />} />

        {/* ⭐ SURPRISE QR ROUTES ⭐ */}
        <Route path="/surprise-categories" element={<SurpriseCategories />} />
        <Route path="/surprise-content" element={<SurpriseContent />} />
        <Route path="/surprise-qr-reports" element={<SurpriseQRReports />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    ),
    []
  );

  return (
    <Router>
      {isAuthenticated ? (
        <>
          <div className="flex">
            <Sidebar sidebarToggle={sidebarToggle} />

            <Navbar
              sidebarToggle={sidebarToggle}
              setSidebarToggle={setSidebarToggle}
              onLogout={handleLogout}
            />
          </div>

          <Layout sidebarToggle={sidebarToggle}>{protectedRoutes}</Layout>

          {/* ⭐ Static Fixed Footer — No Sidebar Props Needed */}
          <Footer />
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<SignIn />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
};

export default App;
